import { db } from '@/main';
var firebase = require("firebase/app");
import router from '@/router'

export default {
	namespaced: true,
	state: {
		user: null,
		logged: false
	},
	mutations: {
		setUser(state, user) {
			if ( user ) {
				state.user = {
					uid: user.uid,
					email: user.email
				};
				state.logged = true;
			} else {
				state.user = null;
				state.logged = false;
			}
		},
	},
	actions: {

		registerUser: ({ commit }, user) => {
			return firebase.auth().createUserWithEmailAndPassword(user.email, user.password);
		},

		loginUser: ({ commit }, user) => {
			return firebase.auth().signInWithEmailAndPassword(user.email, user.pass);
		},

		async checkUser({ commit,dispatch }, payload) {
			if (payload != null) {
				await commit('setUser', { email: payload.email, uid: payload.uid })
				//await dispatch('userModule/getUser', payload.uid, { root: true })
				
			} else {
				commit('setUser', null)
			}
		},
		logOut({ commit,dispatch }) {
			firebase.auth().signOut()
			commit('setUser', null)
			//dispatch('userModule/getUser', null, { root: true })
			router.push({ name: 'Home' })
		},
	},
	getters: {
		logonUser(state) {
			return state.logged
			// if (state.user === null || state.user === '' || state.user === undefined) {
			// 	return false
			// } else {
			// 	return true
			// }
		},
	}
}